import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authenticate');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-authenticate',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authenticate/view.scss */
/* src/app/page.authenticate/view.scss: no such file or directory */`],
})
export class PageAuthenticateComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public returnTo: string = "notset";

    public view: string = 'login.email';

    public data: any = {
        email: '',
        password: ''
    };

    public userOptional = [
        { key: 'phone', label: '휴대전화', placeholder: '010-1234-5678' }
    ];

    public async ngOnInit() {
        await this.service.init();

        let returnTo = this.getParam('returnTo', '/ui/dashboard');
        let check = await this.service.auth.allow(false, returnTo);
        if (check) this.returnTo = returnTo;

        await this.service.render();

        if (this.service.auth.session.block) {
            alert(this.service.auth.session.block);
            await wiz.call("clear");
            await this.service.render();
        }
    }

    public getParam(sname, defaultvalue) {
        let params = location.search.substring(location.search.indexOf("?") + 1);
        let sval = defaultvalue;
        params = params.split("&");
        for (let i = 0; i < params.length; i++) {
            let temp = params[i].split("=");
            if ([temp[0]] == sname) { sval = temp[1]; }
        }
        return decodeURIComponent(sval);
    }

    public async toLogin() {
        this.view = 'login.email';
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (user.password) {
            user.password = this.service.auth.hash(user.password);
        } else {
            delete user.password;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            if (data == 'dormant') {
                this.view = "login.terms";
                await this.service.render();
            } else {
                location.href = this.returnTo;
            }
        } else if (code == 201) {
            this.view = "login.password";
            await this.service.render();
            try {
                setTimeout(() => {
                    const el: any = document.querySelector("input[type=password]");
                    if (el) el.focus();
                }, 150);
            } catch (err) { }
        } else if (code == 301) {
            const msg = (data || "계정을 찾을 수 없습니다.") + "\n\n새 계정을 만드시겠습니까?";
            const isjoin = confirm(msg);
            if (!isjoin) return;

            this.view = "join";
            await this.service.render();
        } else {
            alert(data || "로그인에 실패했습니다. 다시 시도해주세요.");
        }
    }

    public async join_start() {
        this.view = "join";
        await this.service.render();
    }

    public async join() {
        if (!this.data.id || this.data.id.trim().length === 0) {
            alert("아이디를 입력해주세요");
            return;
        }

        if (!this.data.name || this.data.name.length == 0) {
            alert("이름을 입력해주세요");
            return;
        }

        if (!this.data.email || this.data.email.length == 0) {
            alert("이메일을 입력해주세요");
            return;
        }

        if (!this.data.password || this.data.password.length == 0) {
            alert("비밀번호를 입력해주세요");
            return;
        }

        let password = this.data.password;
        let password_re = this.data.password_repeat;

        if (password.length < 8) {
            alert("8글자 이상의 비밀번호를 설정해주세요");
            return;
        }
        if (password.search(/[a-z]/i) < 0) {
            alert("비밀번호에 알파벳을 포함해주세요");
            return;
        }
        if (password.search(/[0-9]/) < 0) {
            alert("비밀번호에 숫자를 포함해주세요");
            return;
        }
        if (password != password_re) {
            alert("비밀번호가 일치하지 않습니다");
            return;
        }

        let user: any = JSON.parse(JSON.stringify(this.data));
        delete user.password_repeat;

        user.password = this.service.auth.hash(user.password);

        const email = this.data.email;

        let { code, data } = await wiz.call("join", user);
        console.log('join result', { code, data });

        if (code == 200) {
            alert("회원가입이 완료되었습니다. 로그인 후 이용해주세요.");

            this.view = 'login.email';

            this.data = {
                email: email,
                password: ''
            };

            await this.service.render();
        } else {
            alert(data || "회원가입에 실패했습니다. 잠시 후 다시 시도해주세요.");
        }
    }

    private onlyDigits(v: string): string {
        return (v || '').replace(/\D/g, '');
    }

    // 한국 휴대폰 기준: 010xxxxxxxx / 011~019 / 02 / 0xx 지역번호까지도 어느정도 커버
    private formatKoreanPhone(v: string): string {
        const d = this.onlyDigits(v).slice(0, 11); // 휴대폰은 최대 11자리(010xxxxxxxx)

        if (!d) return '';

        // 02 (서울) 케이스까지 완전히 맞추려면 분기가 더 필요하지만,
        // 현재 요구는 "휴대폰(010)"이므로 3-4-4 우선 처리
        if (d.startsWith('02')) {
            // (참고) 02-xxxx-xxxx 또는 02-xxx-xxxx
            if (d.length <= 2) return d;
            if (d.length <= 5) return `${d.slice(0, 2)}-${d.slice(2)}`;
            if (d.length <= 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;
            return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6)}`;
        }

        // 010/011/016/017/018/019 등: 3-4-4
        if (d.length <= 3) return d;
        if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
        return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
    }

    public async onPhoneChange(v: string) {
        // 입력 중 자동 하이픈 반영
        this.data.phone = this.formatKoreanPhone(v);
        await this.service.render();
    }
}

export default PageAuthenticateComponent;